"use client";

import React from "react";
import { CheckOutlined } from "@ant-design/icons";

interface WizardProgressProps {
  currentStep: number;
  steps: Array<{ number: number; title: string }>;
}

export const WizardProgress: React.FC<WizardProgressProps> = ({ currentStep, steps }) => {
  return (
    <div className="mx-auto w-100 mw-896 mbx-24">
      <div className="d-flex align-center">
        {steps.map((step, index) => (
          <div
            key={step.number}
            style={{
              display: "flex",
              alignItems: "center",
              flex: index === steps.length - 1 ? "initial" : 1,
            }}
          >
            <div className="d-flex flex-column align-center">
              {/* Circle */}
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor:
                    currentStep >= step.number ? "#030213" : "#ececf0",
                  color: currentStep >= step.number ? "#fff" : "rgb(48, 60, 66)",
                  transition: "background-color 0.3s, color 0.3s",
                }}
              >
                {currentStep > step.number ? (
                  <CheckOutlined style={{ fontSize: 16, color: currentStep >= step.number ? "#fff" : "#717182", }} />
                ) : (
                  <span className="fs-1">{step.number}</span>
                )}
              </div>

              {/* Step Title */}
              <p
                style={{
                  marginTop: 4,
                  fontSize: 14,
                  marginBottom: "0px",
                  textAlign: "center",
                  color: currentStep >= step.number ? "#000" : "#717182",
                  wordWrap: "break-word",
                  fontFamily:
                    "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",

                }}
              >
                {step.title}
              </p>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                style={{
                  height: 2,
                  flex: 1,
                  margin: "0 16px",
                  marginBottom: "36px",
                  backgroundColor: currentStep > step.number ? "#030213" : "#f0f0f0",
                  transition: "background-color 0.3s",
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
